module.exports = __webpack_public_path__ + "img/bj36.32eda9d0.png";